import Vue from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import 'moment/locale/zh-cn';

Vue.use(Antd);
